import { baseUrl } from "./constants";

export async function sendQuotationChatMsg({
  message,
  chat_session_uid,
  source_entity,
  username,
  user_email,
}: {
  message: string;
  chat_session_uid: string;
  source_entity: string;
  username: string;
  user_email: string;
}): Promise<Response | null> {
  const url = `${baseUrl}/api/v1/quotation-request-chat`;
  return fetch(url, {
    method: "POST",
    body: JSON.stringify({ message, chat_session_uid, source_entity, username, user_email }),
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => {
      if (response.status === 400) {
        return null;
      }
      return response;
    })
    .catch(() => {
      return null;
    });
}
